import { INCREMENT, DECREMENT, RESET } from "../actions";
// Reducer for counter
const initialState = { value: 0 };
const counterReducer = (state = initialState, action) => {
    switch (action.type) {
        case INCREMENT:
            fetch("/api/counters/counter", {
			  method: 'PUT',
			  headers: {
				'Content-Type': 'application/json',
			  },
			  body: JSON.stringify({_id:'counter'})
		    });
            return { ...state, value: state.value + 1 };
        case DECREMENT:
            fetch("/api/counters/minus", {
			  method: 'PUT',
			  headers: {
				'Content-Type': 'application/json',
			  },
			  body: JSON.stringify({_id:'minus'})
		    });
            return { ...state, value: Math.max(state.value - 1, 0) };
        case RESET:
            return { ...state, value: 0 };
        default:
            return state;
    }
};
export default counterReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js